import React, { useState } from "react";
import { Tag, Breadcrumb, Card, Modal, message } from "antd";
import { Link } from "react-router-dom";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import useGetFile from "../../hooks/useGetFile";
import useAuthUserToken from "../../hooks/useAuthUserToken";
import {
  SearchOutlined,
  CheckCircleOutlined,
  WarningOutlined,
} from "@ant-design/icons";

const Header = ({
  candidate,
  setLoad,
  breadcrumbs,
  isShowControl = true,
  rehireDetails,
  canResumeCv,
}) => {
  const { userToken } = useAuthUserToken();
  const { imageLoad, getImage } = useGetFile(userToken);
  const [docUrl, setDocUrl] = useState({
    url: "",
    ext: "",
  });

  let resumeFilePath = "";
  let videoFilePath = "";

  const { files } = candidate || {};

  if (files && files?.length !== 0) {
    for (let file of files) {
      if (file.fieldname) {
        if (file.fieldname.toLowerCase().indexOf("resume") !== -1) {
          resumeFilePath = file;
        }
      }
      if (file.fieldname) {
        if (file.fieldname.toLowerCase().indexOf("video") !== -1) {
          videoFilePath = file;
        }
      }
    }
  }

  const [docOpen, setDocOpen] = useState(false);

  const showfile = async (key) => {
    try {
      setLoad(true);

      if (key === "resume" && !resumeFilePath) {
        return message.error("No file uploaded yet.");
      }

      if (key === "video" && !videoFilePath) {
        return message.error("No file uploaded yet.");
      }

      const filePath = key === 'resume' ? resumeFilePath : key === 'video' ? videoFilePath : ""

      if (!filePath) {
        return message.error("No file uploaded yet.");
      }

      const url = await getImage(filePath?.path);
      setDocUrl({
        url: url,
        ext: filePath?.path?.split(".").pop()?.toLowerCase(),
      });
      setDocOpen(true);
    } catch (err) {
      console.log(err);
    } finally {
      setLoad(false);
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-12 p-0">
          <Card className="border mb-4 p-3">
            <div className="row align-items-center">
              <div className="col-md-6">
                <Breadcrumb>
                  {breadcrumbs?.map((item) => {
                    return (
                      <Breadcrumb.Item>
                        {item?.url !== "" ? (
                          <Link
                            style={{
                              color: "black",
                              textDecoration: "underline",
                            }}
                            to={item?.url}
                          >
                            {item?.label}
                          </Link>
                        ) : (
                          <div className="text-capitalize">{item?.label}</div>
                        )}
                      </Breadcrumb.Item>
                    );
                  })}
                </Breadcrumb>
                <h3 className="m-0 fw-bold text-capitalize">
                  {candidate?.name}
                </h3>
              </div>
              {isShowControl && canResumeCv && (
                <div className="col-md-6 text-md-end mt-2 mt-md-0 d-flex justify-content-end gap-3">
                  <button
                    type="button"
                    disabled={!resumeFilePath}
                    className="btn btn-outline-secondary  w-md-auto"
                    onClick={() => showfile("resume")}
                  >
                    <b>Resume</b>
                  </button>
                  <button
                    type="button"
                    disabled={!videoFilePath}
                    className="btn btn-outline-secondary  w-md-auto"
                    onClick={() => showfile("video")}
                  >
                    <b>Video Message</b>
                  </button>
                </div>
              )}
                {rehireDetails && rehireDetails?.length !== 0 && (
                <div className="col-md-6 text-md-end mt-2 mt-md-0 d-flex justify-content-end">
                  <Tag
                    icon={
                      rehireDetails?.[0]?.can_hire_in_future
                        ?.toLowerCase()
                        ?.trim() === "yes" ? (
                        <CheckCircleOutlined />
                      ) : (
                        <WarningOutlined />
                      )
                    }
                    color={
                      rehireDetails?.[0]?.can_hire_in_future
                        ?.toLowerCase()
                        ?.trim() === "yes"
                        ? "#87d068"
                        : "#cd201f"
                    }
                    style={{fontSize:'1rem',padding:'0.3rem'}}
                  >
                    Rehire
                  </Tag>
                  </div>
                )}
            </div>
          </Card>
        </div>
      </div>
      <Modal
        centered
        open={docOpen}
        footer={null}
        onOk={(e) => setDocOpen(!docOpen)}
        onCancel={(e) => setDocOpen(!docOpen)}
        width={800}
        title="Attachment"
      >
        <div style={{ height: "600px", overflowY: "auto" }}>
          {docUrl?.ext === "pdf" && (
            <div style={{ flexGrow: 1 }}>
              <iframe
                style={{ width: "100%", height: "590px" }}
                title="iframe"
                className="iframe"
                width="100%"
                height="400px"
                src={docUrl?.url}
              >
                <p>iframes are not supported by your browser.</p>
              </iframe>
            </div>
          )}
          {(docUrl?.ext?.toLowerCase() === "doc" ||
            docUrl?.ext?.toLowerCase() === "docx") && (
            <div style={{ flexGrow: 1 }} className="resume">
              <DocViewer
                style={{ width: "100%" }}
                config={{
                  header: {
                    disableHeader: true,
                    disableFileName: true,
                  },
                }}
                documents={[
                  {
                    uri: docUrl?.url,
                    fileType: docUrl?.ext,
                  },
                ]}
              />
            </div>
          )}
          {(docUrl?.ext?.toLowerCase() === "png" ||
            docUrl?.ext?.toLowerCase() === "jpg" ||
            docUrl?.ext?.toLowerCase() === "jpeg") && (
            <div style={{ width: "100%" }}>
              <img
                alt="img"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                }}
                src={docUrl?.url}
              />
            </div>
          )}

          {docUrl?.ext?.toLowerCase() === "mp4" && (
            <div
              style={{
                width: "100%",
                height: "600px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <video src={docUrl?.url} controls width="100%"></video>
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};

export default Header;
